import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../components_root/loadingimg.jsx';
import logo_default from "../assets/logo_default.jpg"; 
import Rating from "../view_root/rating.js";
import { IoIosGitCompare } from "react-icons/io";
import Loading from "../components_root/loading.jsx";
import { CiRead } from "react-icons/ci";
import Saved from "../view_root/saved.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
export const seoFallback = {
  title: "aooz | Amazing Products & Tools",
  description: "Check out products and services on aooz.",
  keywords: "aooz products, services, tools",
  url: "https://aooz.in",
  image: "https://aooz.in/assets/logo.png",
};

export default function Category_view({ productId }) {
     const { Toastshow } = Toast(); 
    const userId = Cookies.get("guid"); // Must exist 
     const [titlemete, setTitlemete] = useState("");
     const [keywordsmete, setKeywordsmete] = useState("");
  const meta = {
    title: titlemete || seoFallback.title,
    description: seoFallback.description,
    keywords: keywordsmete || seoFallback.keywords,
    image: seoFallback.image,
    url: `https://aooz.in`,
  };

  return (
    <div className="p-11">
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
      </Helmet>
         <div className="container_roots"></div>
                   <div className="post-container">
                        <div className="post_updates"></div>
                        <div className="post_div"></div>
                   </div>
           
        </div>
    );
}
